import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getEspecialidadMedicoById, updateEspecialidadMedico } from '../services/especialidadMedicoService';
import '../styles/Professions.css';

const EditarEspecialidadMedico = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nombre: '', observacion: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEspecialidad = async () => {
      try {
        const res = await getEspecialidadMedicoById(id);
        const data = Array.isArray(res.data) ? res.data[0] : res.data;
        setForm({
          nombre: data.ESPECIALIDAD_NOMBRE || '',
          observacion: data.ESPECIALIDAD_OBSERVACION || ''
        });
      } catch (error) {
        setErrors({ api: 'No se pudo cargar la especialidad' });
      }
    };
    fetchEspecialidad();
  }, [id]);

  const validateForm = () => {
    const newErrors = {};
    if (!form.nombre.trim()) {
      newErrors.nombre = 'El nombre de la especialidad es requerido';
    } else if (form.nombre.length < 3) {
      newErrors.nombre = 'El nombre debe tener al menos 3 caracteres';
    }
    if (!form.observacion.trim()) {
      newErrors.observacion = 'La observación es requerida';
    } else if (form.observacion.length < 10) {
      newErrors.observacion = 'La observación debe tener al menos 10 caracteres';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      await updateEspecialidadMedico(id, {
        ESPECIALIDAD_NOMBRE: form.nombre,
        ESPECIALIDAD_OBSERVACION: form.observacion
      });
      setLoading(false);
      navigate('/especialidades-medicas');
    } catch (err) {
      setLoading(false);
      setErrors({ api: err.response?.data?.message || 'Error al actualizar especialidad' });
    }
  };

  const handleCancel = () => {
    navigate('/especialidades-medicas');
  };

  return (
    <div className="create-profession-container">
      <div className="header-section">
        <h2>Editar Especialidad Médica</h2>
      </div>
      <form className="profession-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Información de la Especialidad</h3>
          <div className="form-group">
            <label htmlFor="nombre">
              Nombre de la Especialidad <span className="required">*</span>
            </label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={form.nombre}
              onChange={handleChange}
              className={errors.nombre ? 'error' : ''}
              placeholder="Ej: Cardiología"
            />
            {errors.nombre && <span className="error-message">{errors.nombre}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="observacion">
              Observación <span className="required">*</span>
            </label>
            <textarea
              id="observacion"
              name="observacion"
              value={form.observacion}
              onChange={handleChange}
              className={errors.observacion ? 'error' : ''}
              placeholder="Describe la especialidad..."
              rows="4"
            />
            {errors.observacion && <span className="error-message">{errors.observacion}</span>}
          </div>
        </div>
        {errors.api && <div className="form-error">{errors.api}</div>}
        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar Cambios'}
          </button>
          <button type="button" className="btn-secondary" onClick={handleCancel} disabled={loading}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarEspecialidadMedico;
